import React from "react";
import { Container, ContainerInfoUnits, FirstColumn, SecondColumn } from "./styles";

import CartaoVantagens from "../../assets/images/cartao-vantagens.png";
import { formatPrice } from "../../util/format";
import { PriceType } from "../../util/priceType";

const CardSpecialPriceProduct = ({ price }) => {
    const { type, facilityProgram, minimunQuantity, multipleQuantity, takeQuantity, payQuantity, priceBy } = price;
    const isTakeMorePayLess = type === PriceType.TAKEMOREPAYLESS;
    const hasTakeMorePayLessRule = isTakeMorePayLess && takeQuantity && payQuantity;
    const quantityLabel = type === PriceType.MINIMUN ? minimunQuantity : multipleQuantity || takeQuantity;

    return (
        <Container>
            <FirstColumn>
                <ContainerInfoUnits>
                    <span><b>{hasTakeMorePayLessRule ? `Leve ${takeQuantity}` : type === PriceType.MINIMUN ? "A partir de" : "A cada"}</b></span>
                    <br />
                    <span><b>{hasTakeMorePayLessRule ? `Pague ${payQuantity}` : `${quantityLabel} unidade(s)`}</b></span>
                </ContainerInfoUnits>
                {facilityProgram && (
                    <img
                        alt="Cartão Vantagem"
                        src={CartaoVantagens}
                    />
                )}
            </FirstColumn>
            <SecondColumn>
                <span><b>{hasTakeMorePayLessRule ? "Por" : "Pague"}</b> </span>
                <br />
                <span><b>{formatPrice(priceBy)}/cada</b></span>
            </SecondColumn>
        </Container>
    );
}

export default CardSpecialPriceProduct;
